export interface BillableRate {
  id: string;
  scopeOfPractice: string;
  rate: number;
}
